import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Truck, Gift } from 'lucide-react';

const crc = (n) => `₡${Number(n || 0).toLocaleString('es-CR')}`;
const ESTADO = { pendiente_pago: 'Por pagar', pagada: 'Pagada', sin_cargo: 'Sin cargo', entregada: 'Entregada' };

export const MisEntregas = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cliente/entregas`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('sendhapy_token')}` },
    }).then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  const { proxima, reglas } = data;
  const pct = Math.min(100, (proxima.kilos_facturables / reglas.umbral_entrega_gratis_kg) * 100);

  return (
    <div className="mt-6 space-y-4" data-testid="mis-entregas">
      <div className="rounded-xl p-6 text-white" style={{ background: 'var(--sendhapy-teal)' }}>
        <div className="flex items-center gap-2 mb-2"><Truck size={20} style={{ color: 'var(--sendhapy-yellow)' }} /><h3 className="font-semibold text-lg">Entrega local</h3></div>
        <p className="text-white/80 text-sm mb-4">
          Entrega a domicilio {crc(reglas.entrega_crc)} por viaje. <b>Gratis</b> cuando tu entrega suma {reglas.umbral_entrega_gratis_kg} kg facturables o más.
        </p>
        {proxima.paquetes > 0 ? (
          <>
            <div className="h-2 rounded-full bg-white/20 overflow-hidden"><div className="h-full rounded-full transition-all duration-700" style={{ width: `${pct}%`, background: 'var(--sendhapy-yellow)' }} /></div>
            <p className="text-sm mt-2" data-testid="entrega-proxima-msg">
              {proxima.entrega_gratis
                ? `¡Tus ${proxima.paquetes} paquete(s) listos suman ${proxima.kilos_facturables} kg: tu próxima entrega es gratis!`
                : `Tienes ${proxima.kilos_facturables} kg listos. Te faltan ${proxima.falta_para_gratis_kg} kg para entrega gratis.`}
            </p>
          </>
        ) : <p className="text-sm text-white/70">No tienes paquetes listos para entrega en este momento.</p>}
        {data.ahorro_total_crc > 0 && <p className="text-sm mt-3" data-testid="entrega-ahorro-total">Has ahorrado {crc(data.ahorro_total_crc)} en entregas.</p>}
      </div>

      {data.entregas.length > 0 && (
        <div className="bg-white rounded-xl p-6 shadow-sm overflow-x-auto">
          <h4 className="font-semibold mb-3">Mis entregas</h4>
          <table className="w-full text-sm" data-testid="mis-entregas-table">
            <thead><tr className="text-left text-gray-400 border-b"><th className="py-2">N.º</th><th>Paquetes</th><th>Kilos</th><th>Entrega</th><th>Beneficio</th><th>Total</th><th>Estado</th></tr></thead>
            <tbody>
              {data.entregas.map((e) => (
                <tr key={e.entrega_id} className="border-b last:border-0" data-testid={`cliente-entrega-${e.numero}`}>
                  <td className="py-3 font-mono">{e.numero}</td>
                  <td>{e.paquetes.length}</td>
                  <td>{e.kilos_facturables} kg</td>
                  <td className={e.descuento_crc ? 'line-through text-gray-400' : ''}>{crc(e.cargo_estandar_crc)}</td>
                  <td>
                    {e.entrega_gratis && <span className="inline-flex items-center gap-1 text-green-700"><Gift size={14} /> Gratis (ahorras {crc(e.descuento_crc)})</span>}
                    {!e.entrega_gratis && <span className="text-gray-400">—</span>}
                  </td>
                  <td className="font-bold">{crc(e.total_crc)}</td>
                  <td>{ESTADO[e.estado] || e.estado}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
